<template>
	<div class="loading">
		<i class="fas fa-spinner fa-spin"></i>
		<span class="text" v-if="!hideText">{{text || 'Loading'}}&hellip;</span>
	</div>
</template>

<script>
export default {
	name: 'Spinner',
	props: ['text', 'hideText']
};
</script>



// WEBPACK FOOTER //
// ./src/components/Spinner.vue